<template>
    <app-ghost-mode>
        <div class="row">
            <div class="col-md-6 col-sm-8 col-12">
                <form v-if="item">
                    <div class="jumbotron screen-center text-center">
                        <div class="negotiate-header pt-3">
                            <h3 class="md-small-text" v-if="!item.sold">Mark Item As Sold</h3>
                            <template v-else>
                                <h3 class="md-small-text" v-if="confirmedBuyer.buyerId == user._id">Bought Item. Congrats!</h3>
                                <h3 class="md-small-text" v-else>Sold Item. Congrats!</h3>
                            </template>
                        </div>
                        <!-- Alert Messages -->
                        <dl v-if="msg !== ''" class="row mt-3">
                            <dd class="col-12">
                                <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                                    <i class="fas fa-exclamation-circle"></i> {{ msg | capitalize }}
                                </div>
                            </dd>
                        </dl>
                        <div v-if="!item.sold" class="mt-4 mb-2">
                            <p class="font-weight-bold">"{{item.title | capitalize}}"</p>
                            <p class="font-weight-bold text-dark-green text-uppercase">
                                <i class="fas fa-money-bill"></i> {{item.currency}} {{item.price | money}}
                            </p>
                        </div>
                        <template v-if="myItemBuyers">
                            <template v-if="!item.sold">
                                <ul class="list-group text-left">
                                    <li class="list-group-item">
                                        From the list below, who bought this item ?
                                    </li>
                                    <!-- Remember to make this search box work !!! YOUR ATTENTION IS NEEDED HERE !!! -->
                                    <li v-if="myItemBuyers.length > 10" class="list-group-item">
                                        <input type="text" placeholder="search" class="form-control no-lines bg-white">
                                    </li>
                                    <li class="card-body pre-scrollable p-0">
                                        <ul class="list-group list-group-flush">
                                            <li class="list-group-item" v-for="(buyer, i) in myItemBuyers" :key="i">
                                                <input v-model="selectedBuyer" @click="runFetchItemsSeller(buyer.buyerId)" type="radio" name="selectBuyerRadio" :id="i" :value="buyer.buyerId"> 
                                                <label :for="i" class="mx-2 clickable">
                                                    {{ buyer.name | capitalize }} 
                                                    <b class="text-dark-green">@{{buyer.handle}}</b>
                                                </label> 
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <button v-if="!item.sold" @click.prevent="markSoldBtn" class="mt-3 loadn btn btn-dark-green">Mark as Sold</button>
                            </template>
                            <template v-else>
                                <div v-if="confirmedBuyer && confirmedSeller" class="mx-2 mt-5 text-center">
                                    <i class="fas fa-handshake fa-5x"></i>
                                    <p class="text-dark-green font-weight-bold mt-3">
                                        <router-link :to="{ name: 'lookup-handle', params: { handle: confirmedSeller.handle } }">
                                            {{confirmedSeller.name | capitalize}} @{{confirmedSeller.handle}}
                                        </router-link> 
                                        <span class="text-dark">&amp;</span>
                                        <router-link :to="{ name: 'lookup-handle', params: { handle: confirmedBuyer.handle } }">
                                            {{confirmedBuyer.name | capitalize}} @{{confirmedBuyer.handle}} 
                                        </router-link>
                                    </p>
                                    <hr>
                                    <p class="text-muted">"{{item.title}}"</p>
                                    <p class="text-muted text-uppercase">{{confirmedSeller.currency}} {{item.soldPrice | money}}</p>
                                    <div class="pt-3">
                                        <!-- transaction receipt link -->
                                        <router-link v-if="itemTransaction" :to="{ name: 'transactions' }" tag="button" class="text-dark btn btn-light mb-2 mr-2">
                                            <i class="fas fa-receipt text-dark-green"></i> {{itemTransaction.number}}
                                        </router-link>
                                        <template v-if="item.userId == user._id">
                                            <!-- review buyer btn -->
                                            <router-link v-if="item.sellerReviewed" :to="{ name: 'lookup-handle', params: { handle: confirmedBuyer.handle } }" 
                                                class="btn btn-light mb-2">
                                                <i class="fas fa-check text-dark-green"></i> Reviewed Buyer
                                            </router-link>
                                            <button v-else @click="reviewUserBtn('buyer')" class="loadn btn btn-light"><i class="fas fa-star text-warning"></i> Review Buyer</button>
                                        </template>
                                        <template v-else>
                                            <!-- review seller btn -->
                                            <router-link v-if="item.buyerReviewed" :to="{ name: 'lookup-handle', params: { handle: confirmedSeller.handle } }" 
                                                class="btn btn-light mb-2">
                                                <i class="fas fa-check text-dark-green"></i> Reviewed Seller
                                            </router-link>
                                            <button v-else @click="reviewUserBtn('seller')" class="loadn btn btn-light"><i class="fas fa-star text-warning"></i> Review Seller</button>
                                        </template>
                                    </div>
                                    <div class="pt-5"><small>{{item.soldTime | moment("MMMM Do YYYY, h:mm:ss A")}}</small></div>
                                    <div class="pt-3 mb-n5">
                                        <router-link :to="{ name: 'home' }" tag="small" class="text-dark-green clickable">
                                            &copy; aNewItem
                                        </router-link>
                                    </div>
                                </div>
                                <div v-else class="mx-3 mt-5 text-center">
                                    <i class="far fa-frown fa-5x"></i>
                                    <p class="text-dark-green font-weight-bold mt-3">
                                        Something went wrong, let try again later, {{user.name | capitalize}}
                                    </p>
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <ul class="list-group text-center">
                                <li class="list-group-item text-danger">
                                    You don't have a buyer for this item yet!
                                </li>
                            </ul>
                        </template>
                    </div>
                </form>
                <div v-else class="text-center text-danger">Ooops! You're missing the item!</div>
            </div>
        </div>
    </app-ghost-mode>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import GhostMode from '@/components/general/shared/GhostMode.vue'

export default {
    name: "MarkAsSold",
    props: ['itemId'],
    data() {
        return {
            price: '',
            msg: '',
            color: 'danger',
            selectedBuyer: ''
        }
    },
    methods: {
        ...mapActions(['listPostedItem', 'fetchItemBuyers', 'fetchItemsSeller', 'markAnItemAsSold', 'createTransaction', 'reviewTransaction', 'fetchTransactions']),
        runFetchItemDetails() {
            // fetch the new item details using the itemId
            this.listPostedItem(this.itemId)
            .then(() => {
                this.runFetchItemBuyers()
                this.runFetchItemsSeller()
                this.runFetchTransaction()
            })
        },
        runFetchItemBuyers() {
            let itemObj = {
                itemId: this.item._id,
                sellerId: this.item.userId
            }
            this.fetchItemBuyers(itemObj)
        },
        runFetchItemsSeller(selectedBuyerId) {
            let itemObj = {
                itemId: this.item._id,
                buyerId: !selectedBuyerId ? this.item.soldTo : selectedBuyerId
            }
            this.fetchItemsSeller(itemObj)
        },
        runFetchTransaction() {
            let transactionObj = {
                itemId: this.item._id,
                userId: this.user._id,
                promotionId: ""
            }
            this.fetchTransactions(transactionObj)
        },
        markSoldBtn() {
            this.color = "danger"
            if(this.selectedBuyer === ''){ this.msg = "Select your buyer to proceed"; return }
            var itemObj = {
                itemId: this.item._id,
                sellerId: this.item.userId,
                soldPrice: this.item.price,
                buyerId: this.selectedBuyer
            }
            this.markAnItemAsSold(itemObj)
            .then(() => {
                // save transaction log for seller
                let eventObj = {
                    userId: this.user._id,
                    itemId: this.item._id,
                    event: `sold item - ${this.item.title}`
                }
                this.createTransaction(eventObj)
                .then(() => {
                    // save transaction log for buyer
                    let eventObj = {
                        userId: this.selectedBuyer,
                        itemId: this.item._id,
                        event: `bought item - ${this.item.title}`
                    }
                    this.createTransaction(eventObj)
                })

                // run this agian to fetch details for the completed transaction display + transaction-number for receipt
                this.runFetchItemDetails()
            })
            .catch((e) => {
                this.msg = "Marking item as sold failed, try again."
            })
        },
        reviewUserBtn(position) {
            if(this.confirmedBuyer && this.confirmedSeller){
                // determine the user handle
                let theUserHandle = ''
                if(position == 'buyer'){ theUserHandle = this.confirmedBuyer.handle }
                if(position == 'seller'){ theUserHandle = this.confirmedSeller.handle }

                // prepare the review-transaction obj
                let reviewObj = {
                    itemId: this.item._id,
                    sellerId: this.confirmedSeller.sellerId,
                    buyerId: this.confirmedBuyer.buyerId
                }
                this.reviewTransaction(reviewObj)
                .then(() => {
                    this.$router.push({
                        name: 'lookup-handle',
                        params: {
                            handle: theUserHandle,
                            itemId: this.item._id
                        }
                    }).catch((e) => {})
                })
            }
        }
    },
    computed: {
        ...mapGetters(['postedItem', 'user', 'masItemBuyers', 'masItemsSeller', 'transaction']),
        item() {
            if(this.postedItem && this.postedItem !== null){
                return this.postedItem
            }else{
                return false
            }
        },
        itemTransaction() {
            if(this.transaction && this.transaction !== null){
                return this.transaction[0]
            }else{
                return false
            }
        },
        myItemBuyers() {
            if(this.masItemBuyers && this.masItemBuyers.length > 0){
                // the result here must always be one because the sellerId and itemId
                // was specified before sending into runFetchItemBuyers as itemObj
                // thus use [0] to access the first and only returned array value
                return this.masItemBuyers[0].buyers
            }
            return false
        },
        confirmedBuyer() {
            if(this.myItemBuyers){
                let buyerDetails
                for(let x=0; x < this.myItemBuyers.length; x++){
                    if(this.item.soldTo === this.myItemBuyers[x].buyerId){
                        buyerDetails = this.myItemBuyers[x]
                    }
                }
                return buyerDetails
            }
            return false
        },
        confirmedSeller() {
            if(this.masItemsSeller && this.masItemsSeller.length > 0){
                // the result here must always be one because the buyerId and itemId
                // was specified before sending into runFetchItemsSeller as itemObj
                // thus use [0] to access the first and only returned array value
                return this.masItemsSeller[0].seller
            }
            return false
        },
    },
    components: {
        appGhostMode: GhostMode
    },
    mounted() {
        this.runFetchItemDetails()
    }
}
</script>